import React from 'react';

import PropTypes from 'prop-types';

const Discount = ({discount_value, terms}) => (
	<div className="program-promocode__discount">
		<div className="value font-proxima-nova-bold"> { discount_value }</div>
		<div className="text font-proxima-nova-regular">{ terms }</div>
	</div>
);
Discount.propTypes = {
	discount_value: PropTypes.string,
	terms: PropTypes.string
};

export default Discount;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/discounts/components/discount.js